import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import events from './modules/events'
import settings from './modules/settings'
import spots from './modules/spots'
import websocket from './modules/websocket'
import taskpage from './modules/taskpage'
import geolocation from './modules/geolocation'
import taskaudio from './modules/taskaudio'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'app-storage',
  storage: window.localStorage,
  
  reducer: (state) => ({
    settings:{
      app_logged_in:state.settings.app_logged_in,
      app_locale:state.settings.app_locale,
      app_token:state.settings.app_token,
      app_user_id:state.settings.app_user_id,
      app_user_last_logged_in_id:state.settings.app_user_last_logged_in_id,
      app_identifier:state.settings.app_identifier,
      app_settings:state.settings.app_settings
    },
    events:{
      gametype:state.events.gametype,
      selected_event_id:state.events.selected_event_id,
      app_identifier:state.events.app_identifier,
      entered_passwords:state.events.entered_passwords
    }
  })
  /* settings:state.settings */
})

export default new Vuex.Store({
  namespaced: true,
  modules: {
    events,
    settings,
    spots,
    websocket,
    taskpage,
    geolocation,
    taskaudio
  },
  plugins: [vuexPersist.plugin]
})
